export class EventManager {
  constructor() {
    this._events = {};
  }
  addEventListener(eventType, callback) {
    if (!this._events) {
      this._events = {};
    }

    if (!this._events[eventType]) {
      this._events[eventType] = [];
    }

    this._events[eventType].push(callback);
    return callback;
  }

  dispatch(eventType, ...args) {
    if (eventType && this._events[eventType]) {
      this._events[eventType].forEach((listener) => {
        try {
          listener(...args);
        } catch (e) {
          console.error('Some listener function on dispatch event has a problem', e)
        }
      });
    }
  }

  removeEventListener(eventTypeOrCallBack) {
    if (!this._events) {
      this._events = {};
    }

    if (typeof eventTypeOrCallBack === "string") {
      const eventType = eventTypeOrCallBack;
      const eventTarget = this._events[eventType];
      if (eventTarget) {
        this._events[eventType] = [];
      }
    } else if (typeof eventTypeOrCallBack === "function") {
      const targetEvent = eventTypeOrCallBack;
      const eventKeys = Object.keys(this._events);
      eventKeys.forEach((_key) => {
        this._events[_key] = this._events[_key].filter(
          (listener) => listener !== targetEvent
        );
      });
    }
  }

  removeEventListenerAll() {
    this._events = {};
  }
}
